import useSWR from 'swr'
import { fetch, type Params } from './request'
import type { SWRFetchOption } from 'src/modules/apis/hooks/use-fetch'

/**
 * 無料配送PoC
 * https://micin.atlassian.net/wiki/spaces/th/pages/945783606/POC
 */
export const useSWRFetch = (
  params: Params,
  options?: SWRFetchOption<ResolvedType<ReturnType<typeof fetch>>>,
) => {
  const key = `/patients/pharmacies/free_deliveries/search&clinic_uid=${params.clinic_uid}`

  const { data, error } = useSWR(
    params.clinic_uid ? key : null,
    () => fetch(params),
    {
      onSuccess: data => {
        options?.onComplete && options.onComplete(data)
      },
      onError: error => {
        options?.onFailure && options.onFailure(error)
      },
    },
  )

  return {
    data: data || null,
    error,
    loading: !data && !error,
  }
}
